import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Settings } from '../../models/settings';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  private http: HttpClient = inject(HttpClient);
  private adminApiBaseUrl = environment.apiBaseUrl + '/api/admin';

  getSettingsForConnectionByType(
    connectionName: string,
    settingType: string,
  ): Observable<Settings> {
    return this.http.get<Settings>(
      `${this.adminApiBaseUrl}/connections/${connectionName}/settings/${settingType}`,
    );
  }

  updateSettingsForConnectionByType(
    connectionName: string,
    settingType: string,
    settingsValue: unknown,
  ): Observable<unknown> {
    return this.http.patch<unknown>(
      `${this.adminApiBaseUrl}/connections/${connectionName}/settings/${settingType}`,
      {
        settings_value: settingsValue,
      },
    );
  }

  CreateSettingsForConnectionByType(
    connectionName: string,
    settingType: string,
    settingsValue: unknown,
  ): Observable<unknown> {
    return this.http.post<unknown>(
      `${this.adminApiBaseUrl}/connections/${connectionName}/settings/${settingType}`,
      {
        settings_type: settingType,
        settings_value: settingsValue,
      },
    );
  }

  deleteSettingsForConnectionByType(
    connectionName: string,
    settingType: string,
  ): Observable<unknown> {
    return this.http.delete<unknown>(
      `${this.adminApiBaseUrl}/connections/${connectionName}/settings/${settingType}`,
    );
  }
}
